import React, { Component } from 'react';
import { Field, ErrorMessage, useFormikContext, useField } from 'formik';


export const SelectField = ({ ...props }) => {
    const { setFieldValue } = useFormikContext();
    const [field] = useField(props);
    let label = props.label || (props.name.charAt(0).toUpperCase() + props.name.slice(1));
    return (
        <div className="form-group">
            <label htmlFor={props.name}>{props.label}</label>
            <Field id={props.name} className="form-control" name={props.name} as="select" {...props} defaultValue={(field.value && field.value == props.value) || null}>
                <option value="0">Select {props.label}</option>
                {props.items.map(item =>
                    <option key={"item-" + item.id} value={item.id} >{item.name}</option>
                )}
            </Field>
            <ErrorMessage name={props.name} component="div" />
        </div>)
}

